import React from "react";
import { createRoot } from "react-dom/client";
import SignupModalHost from "../components/SignupModalHost";
import { BreaksCampaignProvider } from "../state/BreaksCampaignContext";

const SIGNUP_HOST_ID = "breakscampaign-signup-root";

/**
 * Monterar anmälningsmodalen en gång per sida. Anmälningsknapparna ligger i
 * .cshtml-filerna och märks med data-breaks-signup — SignupModalHost lyssnar
 * på klick i hela dokumentet och öppnar modalen.
 */
export function initBreaksCampaignSignup(): void {
  // Inga anmälningsknappar på sidan — då behövs ingen modal.
  if (!document.querySelector("[data-breaks-signup]")) {
    return;
  }

  // Skydd mot dubbelmontering om init körs fler än en gång.
  if (document.getElementById(SIGNUP_HOST_ID)) {
    return;
  }

  const host = document.createElement("div");
  host.id = SIGNUP_HOST_ID;
  document.body.appendChild(host);

  createRoot(host).render(
    React.createElement(
      BreaksCampaignProvider,
      null,
      React.createElement(SignupModalHost),
    ),
  );
}
